"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _Form["default"];
  }
});
Object.defineProperty(exports, "Field", {
  enumerable: true,
  get: function get() {
    return _Field["default"];
  }
});
exports["default"] = void 0;

var _Form = _interopRequireDefault(require("./Form"));

var _Field = _interopRequireDefault(require("./Field"));

var _Helpers = _interopRequireDefault(require("./shared/Helpers"));

var _Utils = _interopRequireDefault(require("./shared/Utils"));

var _Events = _interopRequireDefault(require("./shared/Events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* shared prototype methods */

/**
  Extend Classes with Prototype
  - - - - - - - - - - - - - - - - - -
  Cannot use Object.assign as @action
  methods on mixins are non-enumerable
*/
var extend = function extend($class, $obj) {
  return $obj.forEach(function (mixin) {
    return Object.getOwnPropertyNames(mixin).forEach(function (name) {
      return $class.prototype[name] = mixin[name];
    });
  });
}; // eslint-disable-line


var shared = [_Helpers["default"], _Utils["default"], _Events["default"]];
extend(_Form["default"], shared);
extend(_Field["default"], shared);
var _default = _Form["default"];
exports["default"] = _default;